import { useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';

// Finaliza a análise/aprovação da edição (inspetor/vendedor) — segue o fluxo.
// Para aprovar: TODAS as fotos editadas aprovadas + uma foto de capa selecionada.
const FinishpproveEditionOrderButton = ({ order }) => {
  const { hasPermissions } = useContext(AuthContext);

  const editedPhotos = (order.photos || []).filter(
    (photo) => photo.photo_type === 'Editada'
  );

  const allApproved =
    editedPhotos.length > 0 &&
    editedPhotos.every((photo) => photo.photo_status === 'Aprovada');

  const hasCover = editedPhotos.some((photo) => photo.is_cover_photo);

  const canApprove = allApproved && hasCover;

  let reason = '';
  if (!allApproved) reason = 'Todas as fotos devem estar aprovadas.';
  else if (!hasCover) reason = 'Selecione uma foto de capa.';

  return (
    <>
      {order.order_status === 'Inspeção de edição' &&
        hasPermissions(['edit_inspection', 'seller_inspection']) && (
          <div className="col-sm col-md-6 col-xl-4 mt-2">
            <button
              className="btn btn-success btn-block col-12"
              type="button"
              disabled={!canApprove}
              data-bs-toggle={canApprove ? 'modal' : undefined}
              data-bs-target={
                canApprove ? '#modal-finish-edit-inspection-order' : undefined
              }
            >
              finalizar análise de edição
            </button>

            {!canApprove && (
              <small className="text-danger d-block mt-1">{reason}</small>
            )}
          </div>
        )}
    </>
  );
};

FinishpproveEditionOrderButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
    photos: PropTypes.arrayOf(Object),
  }).isRequired,
};

export default FinishpproveEditionOrderButton;
